<template>
    <div class="faq-container">
        <div class="container">
            <div class="inner-page-title">{{ $t('home-top5') }}</div>
        </div>
        <div class="faq-top">
            <div class="container faq-container2">
                <div class="faq-tab" v-on:click="() => $router.push(this.localePath({ path: '/faq/my-account'}))">My Account</div>
                <div class="faq-tab" v-on:click="() => $router.push(this.localePath({ path: '/faq/about-vindome'}))">About Vindome</div>
                <div class="faq-tab" v-on:click="() => $router.push(this.localePath({ path: '/faq/my-portfolio'}))">My Portfolio</div>
                <div class="faq-tab" v-on:click="() => $router.push(this.localePath({ path: '/faq/wine-investment'}))">Wine Investment & Selection</div>
                <div class="faq-tab" v-on:click="() => $router.push(this.localePath({ path: '/faq/buy-and-sell'}))">{{ $t('faqnew86') }}</div>
                <div class="faq-tab" v-on:click="() => $router.push(this.localePath({ path: '/faq/storage'}))">Storage & Insurance</div>
                <div class="faq-tab" v-on:click="() => $router.push(this.localePath({ path: '/faq/billing'}))">Billing, Fees & Taxes</div>
                <div class="faq-tab" v-on:click="() => $router.push(this.localePath({ path: '/faq/delivery'}))">{{ $t('delivery') }}</div>
                <div class="faq-tab" v-on:click="() => $router.push(this.localePath({ path: '/faq/using-the-app'}))">{{ $t('using-the-app') }}</div>
            </div>
        </div>
        <div class="container faq-container2">
            <div class="subtitle">Most viewed questions</div>

            <div class="questions-wrapper">
                <div class="faq-q" v-on:click="() => $router.push(this.localePath({ path: '/faq/1'}))">{{ $t('faq5') }}</div>
                <div class="faq-q" v-on:click="() => $router.push(this.localePath({ path: '/faq/7'}))">{{ $t('faq58') }}</div>
                <div class="faq-q" v-on:click="() => $router.push(this.localePath({ path: '/faq/17'}))">{{ $t('faq69') }}</div>
                <div class="faq-q" v-on:click="() => $router.push(this.localePath({ path: '/faq/19'}))">{{ $t('faq77') }}</div>
                <div class="faq-q" v-on:click="() => $router.push(this.localePath({ path: '/faq/20'}))">{{ $t('faq79') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Faq",
        head: {
            title: 'FAQ | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-faq trading-desk'
            }
        }
    }
</script>

<style scoped>
    .questions-wrapper {
        margin: 70px 0;
    }
    .faq-q {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 19px;
        line-height: 120%;
        color: #303030;
        padding: 17px 0;
    }
    .faq-q:hover {
        cursor: pointer;
        text-decoration: underline;
    }
    .subtitle {
        margin-top: 33px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 39.06px;
        line-height: 120%;
        text-align: center;
        color: #303030;
    }
    .faq-top {
        background: #f6f6f6;
        padding: 32px 94px;
    }
    .faq-tab {
        display: inline-block;
        padding: 0;
        position: static;
        width: calc((100% - 41px) / 3);
        height: 60px;
        line-height: 58px;
        left: 0;
        top: 0;
        background: #FFFFFF;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0 16px 0 0;
        text-align: center;
    }
    .faq-tab:nth-child(1),
    .faq-tab:nth-child(2),
    .faq-tab:nth-child(3),
    .faq-tab:nth-child(43),
    .faq-tab:nth-child(5),
    .faq-tab:nth-child(6) {
        margin-bottom: 16px;
    }
    .faq-tab:nth-child(3),
    .faq-tab:nth-child(6),
    .faq-tab:nth-child(9) {
        margin-right: 0;
    }
    .faq-tab:hover,
    .faq-tab.active {
        background: #707070;
        color: #ffffff;
        cursor: pointer;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
    }
    .faq-container {
        background: #ffffff;
        padding-top: 80px;
    }
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    }
    .inner-page-title {
        font-size: 49px;
        line-height: 49px;
        text-align: center;
        color: #303030;
        margin-top: 47px;
        margin-bottom: 40px;
    }
    .inner-page-title2 {
        font-size: 49px;
        line-height: 49px;
        text-align: center;
        color: #303030;
        margin-top: 23px;
        margin-bottom: 40px;
    }
    .faq-body {
        padding: 0 0 71px 0;
        font-size: 16px;
        font-weight: 400;
    }
    .faq-item {
        font-size: 16px;
        font-weight: 300;
        line-height: 26px;
        color: #000000;
    }
    .faq-item h2 {
        margin: 30px 0 20px;
        font-size: 25px;
        line-height: 30px;
        font-weight: 700;
        color: #303030;
    }
    .faq-body .faq-item:last-of-type {
        border: 0
    }
    .faq-item strong {
        font-weight: 500;
    }
    .show-mobile {
        display: none;
    }
    @media (max-width: 767px) {
        .faq-body {
            padding-left: 15px;
            padding-right: 15px;
        }
        .faq-item h2 {
            font-size: 18px;
            line-height: 22px;
        }
        .show-mobile {
            display: block;
        }
        .hide-mobile {
            display: none;
        }
        .inner-page-title {
            font-size: 30px;
            line-height: 33px;
        }
      .faq-top {
        padding: 32px;
      }
      .faq-tab {
        display: block;
        width: 100%;
      }
      .faq-tab:nth-child(4),
      .faq-tab:nth-child(5) {
        margin-bottom: 16px;
      }
      .faq-container2 {
        padding: 0 16px;
      }
    }
</style>
<style>
    .page-faq .theme--light.v-application {
        background: #ffffff;
    }
    .page-faq .header-toolbar {
        box-shadow: none;
    }
    .page-faq .v-expansion-panel:before {
        box-shadow: none;
    }
    .page-faq .v-expansion-panel-header {
        padding: 0 0 0 55px;
        background: url('../assets/plus.png') no-repeat 20px center;
    }
    .faq-container .v-expansion-panel--active .v-expansion-panel-header {
        background: url('../assets/minus.png') no-repeat 20px center;
    }
    .page-faq .v-expansion-panel-header__icon {
        display: none;
    }
    .theme--light.v-expansion-panels .v-expansion-panel:not(:first-child):after {
        border: 0;
    }
    .page-faq .v-expansion-panel-content__wrap {
        padding-left: 55px;
    }
</style>
